/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  GetCompanyLicenseResponse,
  GetCompanyResponse,
  GetCompanySettingsResponse,
  UpdateCompanyRequest,
  UpdateCompanyResponse,
} from "./models";
import {
  getCompanyLicenseResponseSchema,
  getCompanyResponseSchema,
  getCompanySettingsResponseSchema,
  updateCompanyResponseSchema,
} from "./schemas";

export class OrgCompaniesApiClient {
  constructor(private caller: ApiCaller) {}

  async updateCompany(
    payload: UpdateCompanyRequest,
    timeout?: number,
  ): Promise<UpdateCompanyResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.org.v1.companies.update",
        variables: {},
      },
      "updateCompany",
      payload,
      { schema: updateCompanyResponseSchema, timeout },
    );
  }

  async getCompany(timeout?: number): Promise<GetCompanyResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.org.v1.companies.get",
        variables: {},
      },
      "getCompany",
      {},
      { schema: getCompanyResponseSchema, timeout },
    );
  }

  async getCompanySettings(timeout?: number): Promise<GetCompanySettingsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.org.v1.companies.settings.get",
        variables: {},
      },
      "getCompanySettings",
      {},
      { schema: getCompanySettingsResponseSchema, timeout },
    );
  }

  async getCompanyLicense(timeout?: number): Promise<GetCompanyLicenseResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.org.v1.companies.license.get",
        variables: {},
      },
      "getCompanyLicense",
      {},
      { schema: getCompanyLicenseResponseSchema, timeout },
    );
  }
}
